import { put, call, takeEvery } from "redux-saga/effects"
import { authRequest } from "src/engine/modules/authRequest"
import env from "src/env"
import { REQUESTED_API_ENTITY } from "../actions/types"

import {
  requestApiEntitySuccess,
  requestApiEntityError,
} from "../actions/creators"

const { REACT_APP_API_URL } = env

function* request(action) {
  const {
    config: { name, urlName, uuid },
  } = action
  try {
    const response = yield call(authRequest, {
      url: `${REACT_APP_API_URL}/${urlName || name}/${uuid}`,
      method: `get`,
    })
    yield put(requestApiEntitySuccess(action, response))
  } catch (error) {
    yield put(requestApiEntityError(action, error))
  }
}

export default function* requestSaga() {
  yield takeEvery(REQUESTED_API_ENTITY, request)
}
